<!-- URL https://github.com/ueberdosis/tiptap#readme  max-width:100%;height:auto-->
<template>
  <div style="height: 100% !important;">
    <span class="titleslight--text font-weight-bold">{{ titulo }}</span>
    <span v-if="obligatorio" class="titleslight--text font-weight-bold ml-1"
      >*</span
    >
    <div class="editor">
      <editor-menu-bubble
        :editor="editor"
        @hide="hideLinkMenu"
        v-slot="{ commands, isActive, getMarkAttrs, menu }"
      >
        <div
          class="menubar"
          :class="{ 'is-active': menu.isActive }"
          :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
        >
          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            :class="{ 'is-active': isActive.bold() }"
            @click="commands.bold"
          >
            <v-icon>fas fa-bold</v-icon>
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            :class="{ 'is-active': isActive.italic() }"
            @click="commands.italic"
          >
            <v-icon>fas fa-italic</v-icon>
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            :class="{ 'is-active': isActive.strike() }"
            @click="commands.strike"
          >
            <v-icon>fas fa-strikethrough</v-icon>
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            :class="{ 'is-active': isActive.underline() }"
            @click="commands.underline"
          >
            <v-icon>fas fa-underline</v-icon>
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            :class="{ 'is-active': isActive.code() }"
            @click="commands.code"
          >
            <v-icon>fas fa-code</v-icon>
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            :class="{ 'is-active': isActive.paragraph() }"
            @click="commands.paragraph"
          >
            <v-icon>fas fa-paragraph</v-icon>
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            :class="{ 'is-active': isActive.heading({ level: 1 }) }"
            @click="commands.heading({ level: 1 })"
          >
            H1
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            :class="{ 'is-active': isActive.heading({ level: 2 }) }"
            @click="commands.heading({ level: 2 })"
          >
            H2
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            :class="{ 'is-active': isActive.heading({ level: 3 }) }"
            @click="commands.heading({ level: 3 })"
          >
            H3
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            :class="{ 'is-active': isActive.bullet_list() }"
            @click="commands.bullet_list"
          >
            <v-icon>fas fa-list-ul</v-icon>
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            :class="{ 'is-active': isActive.ordered_list() }"
            @click="commands.ordered_list"
          >
            <v-icon>fas fa-list-ol</v-icon>
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            :class="{ 'is-active': isActive.blockquote() }"
            @click="commands.blockquote"
          >
            <v-icon>fas fa-quote-right</v-icon>
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            :class="{ 'is-active': isActive.code_block() }"
            @click="commands.code_block"
          >
            <v-icon>fas fa-code</v-icon>
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            @click="commands.horizontal_rule"
          >
            <v-icon>fas fa-minus</v-icon>
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            @click="commands.undo"
          >
            <v-icon>fas fa-undo</v-icon>
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            @click="commands.redo"
          >
            <v-icon>fas fa-redo</v-icon>
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            @click="showImagePrompt(commands.image)"
          >
            <v-icon>fas fa-image</v-icon>
          </v-btn>

          <v-btn
            class="menubar__button ma-0"
            text
            icon
            color="black lighten-2"
            @click="showVideoPrompt(commands.iframe)"
          >
            <v-icon>fas fa-video</v-icon>
          </v-btn>
          <v-form
            class="menububble__form pa-4"
            v-if="linkMenuIsActive"
            @submit.prevent="setLinkUrl(commands.link, linkUrl)"
            v-model="valid"
          >
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    class="menububble__input"
                    v-model="linkUrl"
                    label="Url"
                    placeholder="https://"
                    @keydown.esc="hideLinkMenu"
                    ref="linkInput"
                    required
                  ></v-text-field>
                </v-col>
                
                <v-col cols="12" md="4">
                  <v-btn
                    class="menububble__button ma-0"
                    text
                    icon
                    color="black lighten-2"
                    @click="setLinkUrl(commands.link, null)"
                    type="button"
                  >
                    <v-icon>fas fa-trash</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>

          <template v-else>
            <v-btn
              class="menububble__button ma-0"
              text
              icon
              color="black lighten-2"
              @click="showLinkMenu(getMarkAttrs('link'))"
              :class="{ 'is-active': isActive.link() }"
            >
              <v-icon>fas fa-link</v-icon>
            </v-btn>
          </template>
        </div>
      </editor-menu-bubble>
      <editor-content style="border: 1px solid #000;" :editor="editor" />
    </div>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBubble } from "tiptap";
import Iframe from "@/assets/iFrame.js";
import Image from "@/assets/iImage.js";

import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  TrailingNode,
} from "tiptap-extensions";
export default {
  name: "FormHTMLEditor",
  components: {
    EditorMenuBubble,
    EditorContent,
  },
  props: {
    value: { type: String, default: "" },
    titulo: {
      type: String,
      default: "",
    },
    obligatorio: {
      type: Boolean,
      default: false,
    },
    campo: {
      type: String,
      default: "",
    },
    editable: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      valor: this.value,
      esError: false,
      noVacio: [(v) => !!v],
      bEditable: this.editable == "0" ? true : false,
      editor: null,
      linkUrl: null,
      linkMenuIsActive: false,
      /*ReglasUrl: [
        v => /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%\/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/.test(v) || 'Url no válida',
      ],*/
    };
  },
  mounted() {
    this.editor = new Editor({
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new Image(),
        new TrailingNode(),
        // extension personalizada
        new Iframe(),
      ],
      content: this.valor,
      onUpdate: (event) => this.onActualizarDato(event),
    });
  },
  methods: {
    showLinkMenu(attrs) {
      this.linkUrl = attrs.href;
      this.linkMenuIsActive = true;
      this.$nextTick(() => {
        this.$refs.linkInput.focus();
      });
    },
    hideLinkMenu() {
      this.linkUrl = null;
      this.linkMenuIsActive = false;
    },
    setLinkUrl(command, url) {
      command({ href: url });
      this.hideLinkMenu();
    },
    showImagePrompt(command) {
      const src = prompt("Ingresa una url de una imagen para insertar");
      if (src !== null) {
        command({ src });
      }
    },
    showVideoPrompt(command) {
      const src = prompt("Ingresa una url de un video para insertar");
      if (src !== null) {
        command({ src });
      }
    },
    onActualizarDato(event) {
      this.valor = event.getHTML();
    },
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  watch: {
    valor(NewValor, OldValor) {
      if(OldValor == "" && NewValor!=""){
        this.editor.setContent(NewValor)
      }
      this.$emit("input", NewValor);
      
      if (this.esError && this.valor != "") {
        this.esError = false;
      }
    },
    value(NewValue) {
      this.valor = NewValue;
    },
    getoFormError() {
      this.esError = this.getoFormError[this.campo];
    },
  },
};
</script>

<style lang="scss" scoped>
$color-black: #000000;
$color-white: #ffffff;
$color-grey: #dddddd;

.editor__content .editor {
  position: relative;
  max-width: 30rem;
  margin: 0 auto 5rem auto;

  &__content {
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;

    * {
      caret-color: currentColor;
    }

    pre {
      padding: 0.7rem 1rem;
      border-radius: 5px;
      background: $color-black;
      color: $color-white;
      font-size: 0.8rem;
      overflow-x: auto;

      code {
        display: block;
      }
    }

    p code {
      padding: 0.2rem 0.4rem;
      border-radius: 5px;
      font-size: 0.8rem;
      font-weight: bold;
      background: rgba($color-black, 0.1);
      color: rgba($color-black, 0.8);
    }

    ul,
    ol {
      padding-left: 1rem;
    }

    li > p,
    li > ol,
    li > ul {
      margin: 0;
    }

    a {
      color: inherit;
    }

    blockquote {
      border-left: 3px solid rgba($color-black, 0.1);
      color: rgba($color-black, 0.8);
      padding-left: 0.8rem;
      font-style: italic;

      p {
        margin: 0;
      }
    }

    img {
      max-width: 100%;
      border-radius: 3px;
    }

    table {
      border-collapse: collapse;
      table-layout: fixed;
      width: 100%;
      margin: 0;
      overflow: hidden;

      td,
      th {
        min-width: 1em;
        border: 2px solid $color-grey;
        padding: 3px 5px;
        vertical-align: top;
        box-sizing: border-box;
        position: relative;
        > * {
          margin-bottom: 0;
        }
      }

      th {
        font-weight: bold;
        text-align: left;
      }

      .selectedCell:after {
        z-index: 2;
        position: absolute;
        content: "";
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(200, 200, 255, 0.4);
        pointer-events: none;
      }

      .column-resize-handle {
        position: absolute;
        right: -2px;
        top: 0;
        bottom: 0;
        width: 4px;
        z-index: 20;
        background-color: #adf;
        pointer-events: none;
      }
    }

    .tableWrapper {
      margin: 1em 0;
      overflow-x: auto;
    }

    .resize-cursor {
      cursor: ew-resize;
      cursor: col-resize;
    }
  }
}

.menubar {
  margin-bottom: 1rem;
  transition: visibility 0.2s 0.4s, opacity 0.2s 0.4s;

  &.is-hidden {
    visibility: hidden;
    opacity: 0;
  }

  &.is-focused {
    visibility: visible;
    opacity: 1;
    transition: visibility 0.2s, opacity 0.2s;
  }

  &__button {
    font-weight: bold;
    display: inline-flex;
    background: transparent;
    border: 0;
    color: $color-black;
    padding: 0.2rem 0.5rem;
    margin-right: 0.2rem;
    border-radius: 3px;
    cursor: pointer;

    &:hover {
      background-color: rgba($color-black, 0.05);
    }

    &.is-active {
      background-color: rgba($color-black, 0.1);
    }
  }

  span#{&}__button {
    font-size: 13.3333px;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-touch-callout: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;

  &:focus {
    outline: none;
  }
}

*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: "Inter";
  font-size: 18px;
  color: $color-black;
  line-height: 1.5;
}

body {
  margin: 0;
}

a {
  color: inherit;
}

h1,
h2,
h3,
p,
ul,
ol,
pre,
blockquote {
  margin: 1rem 0;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

h1,
h2,
h3 {
  line-height: 1.3;
}

.button {
  font-weight: bold;
  display: inline-flex;
  background: transparent;
  border: 0;
  color: $color-black;
  padding: 0.2rem 0.5rem;
  margin-right: 0.2rem;
  border-radius: 3px;
  cursor: pointer;
  background-color: rgba($color-black, 0.1);

  &:hover {
    background-color: rgba($color-black, 0.15);
  }
}

.message {
  background-color: rgba($color-black, 0.05);
  color: rgba($color-black, 0.7);
  padding: 1rem;
  border-radius: 6px;
  margin-bottom: 1.5rem;
  font-style: italic;
}
.menububble {
  position: absolute;
  display: flex;
  z-index: 20;
  background: $color-black;
  border-radius: 5px;
  padding: 0.3rem;
  margin-bottom: 0.5rem;
  transform: translateX(-50%);
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s, visibility 0.2s;

  &.is-active {
    opacity: 1;
    visibility: visible;
  }

  &__button {
    display: inline-flex;
    background: transparent;
    border: 0;
    color: $color-white;
    padding: 0.2rem 0.5rem;
    margin-right: 0.2rem;
    border-radius: 3px;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      background-color: rgba($color-white, 0.1);
    }

    &.is-active {
      background-color: rgba($color-white, 0.2);
    }
  }

  &__form {
    display: flex;
    align-items: center;
  }

  &__input {
    font: inherit;
    border: none;
    background: transparent;
    color: $color-white;
  }
}
</style>
